module.exports = "<h3 class=\"mod_h3__no_top_margin\">{{'news' | translate }}</h3>\r\n<div ng-bind-html=\"vm.trustedHtml(vm.news.content.est.value)\"></div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/shared/directives/news.directive.html
 ** module id = 57
 ** module chunks = 0
 **/